// https://stackoverflow.com/a/32749533/1159326

import { Task } from 'packages/lib/api/annotations/contract/task';

// https://gist.github.com/dguo/acdfdc87ee4fc500af23091f2fff31da
export class CustomErrorBase extends Error {
  constructor(message?: string, options?: ErrorOptions) {
    super(message);
    this.name = this.constructor.name;
    if (typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, this.constructor);
    } else {
      this.stack = new Error(message).stack;
    }
    Object.setPrototypeOf(this, CustomErrorBase.prototype);
  }
}

export class UnexpectedResponseType extends CustomErrorBase {
  constructor(public response: Response) {
    super(
      `Invalid API Response for ${response.url}, verify API contract has not changed`
    );
    Object.setPrototypeOf(this, UnexpectedResponseType.prototype);
  }
}

export class ResponseNotOk extends CustomErrorBase {
  constructor(public response: Response) {
    super(`non-200 API Response (code ${response.status}) for ${response.url}`);
    Object.setPrototypeOf(this, ResponseNotOk.prototype);
  }
}

export class TaskHasInvalidObjectTokenError extends CustomErrorBase {
  constructor(message: string, public task: Task) {
    super(message);
    this.task = task;
    Object.setPrototypeOf(this, TaskHasInvalidObjectTokenError.prototype);
  }
}

export class DataCollisionError extends CustomErrorBase {
  constructor(message?: string) {
    super(`Data Collision: ${message}`);
    Object.setPrototypeOf(this, DataCollisionError.prototype);
  }
}

export const isCollisionError = (err: unknown): err is DataCollisionError =>
  err instanceof DataCollisionError ||
  (err as Error).message.startsWith('Data Collision: ');
